import { Sparkles } from 'lucide-react';
import React from 'react'

const NoSubscription = () => {
  return (
    <div className="w-full rounded-lg border text-center flex flex-col justify-center items-center">
      <div className="size-14 rounded-2xl bg-blue-50 flex items-center justify-center ">
        <Sparkles size={18} className="text-blue-600" />
      </div>
      <h3 className="text-lg font-semibold text-muted">
        No active subscription
      </h3>
    </div>
  );
}

export default NoSubscription